import _ from 'lodash';
import { analytics } from 'barnyard/utils';

import {
  analyticsTypes as alertAnalyticsTypes,
  analyticsActions as alertAnalyticsActions
} from './alerts';
import {
  analyticsTypes as campaignAnalyticsTypes,
  analyticsActions as campaignAnalyticsActions
} from './campaigns';
import {
  analyticsTypes as searchAnalyticsTypes,
  analyticsActions as searchAnalyticsActions
} from './search';
import {
  analyticsTypes as loyaltyAnalyticsTypes,
  analyticsActions as loyaltyAnalyticsActions
} from './loyalty';
import {
  analyticsTypes as cartsAnalyticsTypes,
  analyticsActions as cartsAnalyticsActions
} from './carts';
import {
  analyticsTypes as signupAnalyticsTypes,
  analyticsActions as signupAnalyticsActions
} from './signup';
import {
  analyticsTypes as checkoutAnalyticsTypes,
  analyticsActions as checkoutAnalyticsActions
} from './checkouts';
import {
  analyticsTypes as etailerAnalyticsTypes,
  analyticsActions as etailerAnalyticsActions
} from './etailer';
import {
  analyticsTypes as incentivesAnalyticsTypes,
  analyticsActions as incentivesAnalyticsActions
} from './incentives';
import {
  analyticsTypes as requisitionsAnalyticsTypes,
  analyticsActions as requisitionsAnalyticsActions
} from './requisitions';
import {
  analyticsTypes as biomatrixAnalyticsTypes,
  analyticsActions as biomatrixAnalyticsActions
} from './biomatrix';
import {
  analyticsTypes as dashboardAnalyticsTypes,
  analyticsActions as dashboardAnalyticsActions
} from './dashboard';
import {
  analyticsTypes as integrationsAnalyticsTypes,
  analyticsActions as integrationsAnalyticsActions
} from './integrations';
import {
  analyticsTypes as savingsAnalyticsTypes,
  analyticsActions as savingsAnalyticsActions
} from './savings';
import {
  analyticsTypes as usersAnalyticsTypes,
  analyticsActions as usersAnalyticsActions
} from './users';
import {
  analyticsTypes as homeDeliveryAnalyticsTypes,
  analyticsActions as homeDeliveryAnalyticsActions
} from './homedelivery';
/*
  A lookup of analytics types to the event name that they'll
  be used for tracking actions
*/
const analyticsTypes = _.merge(
  {
    USER: 'user',
    BUYER: 'buyer',
  },
  alertAnalyticsTypes,
  campaignAnalyticsTypes,
  searchAnalyticsTypes,
  loyaltyAnalyticsTypes,
  cartsAnalyticsTypes,
  signupAnalyticsTypes,
  checkoutAnalyticsTypes,
  etailerAnalyticsTypes,
  incentivesAnalyticsTypes,
  requisitionsAnalyticsTypes,
  biomatrixAnalyticsTypes,
  dashboardAnalyticsTypes,
  integrationsAnalyticsTypes,
  savingsAnalyticsTypes,
  usersAnalyticsTypes,
  homeDeliveryAnalyticsTypes
);

/*
    A list of analytics actions that we'll be using within the app
*/
const analyticsActions = _.concat(
  [],
  alertAnalyticsActions,
  campaignAnalyticsActions,
  searchAnalyticsActions,
  loyaltyAnalyticsActions,
  cartsAnalyticsActions,
  signupAnalyticsActions,
  checkoutAnalyticsActions,
  etailerAnalyticsActions,
  incentivesAnalyticsActions,
  requisitionsAnalyticsActions,
  biomatrixAnalyticsActions,
  dashboardAnalyticsActions,
  integrationsAnalyticsActions,
  savingsAnalyticsActions,
  usersAnalyticsActions,
  homeDeliveryAnalyticsActions
);

/*
  A simple default extract that will merge any / all of the objects passed to itZ
*/
const defaultExtractor = (...p) => _.merge({}, ...p);

/*
  Setup a list of analytics actions that we have defined and can call from within the app
*/
const analyticsWrapper = {};

// Add in the user tracking
analyticsWrapper[analyticsTypes.USER] = (user, buyer) => analytics.identify(
  user.id,
  {
    is_staff: user.is_staff,
    is_cove_crew: user.is_cove_crew,
    email: user.email,
    buyer_id: buyer.id,
    buyer_name: buyer.name
  }
);

// Add in the buyer identification
analyticsWrapper[analyticsTypes.BUYER] = buyer => analytics.group(
  `buyer_${buyer.id}`,
  {
    type: 'buyer',
    name: buyer.name,
    is_beta: buyer.is_beta,
    has_updated_information: buyer.has_updated_information
  }
);

// Add all of the actions to the trackWrapper
_.map(analyticsActions, (action) => {
  if (!action || !action.type) {
    console.warn('Attempted to setup action without a valid type:', action);  // eslint-disable-line
    return;
  }
  let attributesExtractorFxn = defaultExtractor;

  if (_.isFunction(action.attributesExtractor)) {
    attributesExtractorFxn = action.attributesExtractor;
  }

  try {
    analyticsWrapper[action.type] = (...p) => analytics.trackAction(
      action.type,
      attributesExtractorFxn(...p),
    );
  } catch {
    // Skip
  }
});

const track = (analyticsType, ...p) => {
  // If it's not a function, no bother in calling it. Let's warn and move on
  if (!_.isFunction(analyticsWrapper[analyticsType])) {
    console.warn(`Attempting to track ${analyticsType} which does not have a wrapper`);  // eslint-disable-line
    return;
  }

  analyticsWrapper[analyticsType](...p);
};

export default track;

export { analyticsTypes };
